var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.options),function({ id, label },index){return _c('button',{key:id,staticClass:"flex-1 py-2.5 border text-sm font-semibold hover:border-purple hover:bg-purple hover:text-white",class:{
            'rounded-l': index === 0,
            'rounded-r': index === _vm.options.length - 1,
            'bg-white hover:border-purple hover:bg-purple hover:text-white': _vm.value !== id,
            'border-purple bg-purple text-white': _vm.value === id
        },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', id)}}},[_vm._v("\n        "+_vm._s(label)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }